import { ITheme } from "../../utils/theme";

export const subHeaderStyle = {
  mt: 4,
  mb: 1,
}

export const bulletinIconStyle = {
  width: '8px',
  position: 'relative',
  top: '7px',
  mr: 1.5
}

export const goToTopStyle = {
  color: (theme: ITheme) => theme.palette.blue[600],
  float: 'right',
  mr: 3
}

export const questionStyle = {
  ml: 2,
  display: 'block',
  textDecoration: 'none',
  color: 'black',
  cursor: 'pointer',
}